module.exports = __webpack_public_path__ + "static/media/2.fb74c1e2.png";